import './styles.css';
import { Game } from './game/Game.js';
import { createRenderer } from './game/renderer.js';

const canvas = document.querySelector('#game-canvas');
const app = document.querySelector('#app');
const renderer = await createRenderer(canvas);
new Game({ renderer, canvas, root: app });
